import { Terminal, ExternalLink } from "lucide-react";
import { FOOTER_DISCLAIMER } from "@/data/site";
import { AFFILIATE_DISCLOSURE } from "@/components/content/PartnerCta";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="py-16 relative noise-bg">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="grid lg:grid-cols-12 gap-12 mb-16">
          {/* Brand */}
          <div className="lg:col-span-5">
            <a href="/" className="flex items-center gap-3 mb-6">
              <Terminal className="h-5 w-5 text-primary" />
              <span className="font-mono font-semibold text-sm tracking-wider uppercase">
                PeptideX<span className="text-primary">.ai</span>
              </span>
            </a>
            <p className="text-sm max-w-sm leading-relaxed mb-8 text-muted-foreground">
              Plain-English facts on peptides and weight-loss drugs: what's FDA-approved, what's still being tested, and what it costs.
            </p>
          </div>

          {/* Links */}
          <div className="lg:col-span-7">
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-8">
              <div>
                <h2 className="text-sm font-semibold text-muted-foreground mb-5">Site</h2>
                <ul className="space-y-3">
                  <li><a href="/peptide-horizon" className="text-sm text-muted-foreground hover:text-primary transition-colors">Approval tracker</a></li>
                  <li><a href="/compounds" className="text-sm text-muted-foreground hover:text-primary transition-colors">Peptides</a></li>
                  <li><a href="/glp-1-cost" className="text-sm text-muted-foreground hover:text-primary transition-colors">GLP-1 cost</a></li>
                  <li><a href="/compare/retatrutide-vs-zepbound-mounjaro-wegovy" className="text-sm text-muted-foreground hover:text-primary transition-colors">Compare</a></li>
                  <li><a href="/blog" className="text-sm text-muted-foreground hover:text-primary transition-colors">Articles</a></li>
                  <li><a href="/policy" className="text-sm text-muted-foreground hover:text-primary transition-colors">News</a></li>
                  <li><a href="/hhs-503a-peptides" className="text-sm text-muted-foreground hover:text-primary transition-colors">The HHS peptide proposal, explained</a></li>
                  <li><a href="/alerts" className="text-sm text-muted-foreground hover:text-primary transition-colors">Email alerts</a></li>
                </ul>
              </div>
              <div>
                <h2 className="text-sm font-semibold text-muted-foreground mb-5">Our tools (external)</h2>
                <ul className="space-y-3">
                  <li><a href="https://startreta.com" target="_blank" rel="noopener noreferrer" className="text-sm text-muted-foreground hover:text-primary transition-colors inline-flex items-center gap-1">StartReta <ExternalLink className="h-3 w-3" aria-hidden="true" /></a></li>
                  <li><a href="https://healthflex.ai" target="_blank" rel="noopener noreferrer" className="text-sm text-muted-foreground hover:text-primary transition-colors inline-flex items-center gap-1">HealthFlex <ExternalLink className="h-3 w-3" aria-hidden="true" /></a></li>
                </ul>
              </div>
              <div>
                <h2 className="text-sm font-semibold text-muted-foreground mb-5">
                  Legal
                </h2>
                <ul className="space-y-3">
                  <li><a href="/terms" className="text-sm text-muted-foreground hover:text-primary transition-colors">Terms of Service</a></li>
                  <li><a href="/privacy-policy" className="text-sm text-muted-foreground hover:text-primary transition-colors">Privacy Policy</a></li>
                  <li><a href="/disclaimer" className="text-sm text-muted-foreground hover:text-primary transition-colors">Medical & editorial disclaimer</a></li>
                  <li><a href="/disclosures" className="text-sm text-muted-foreground hover:text-primary transition-colors">Disclosures</a></li>
                  <li><a href="/editorial-policy" className="text-sm text-muted-foreground hover:text-primary transition-colors">Editorial policy</a></li>
                                  </ul>
              </div>
              <div>
                <h2 className="text-sm font-semibold text-muted-foreground mb-5">
                  Connect
                </h2>
                <ul className="space-y-3">
                  <li>
                    <a href="https://x.com/PeptideXai" target="_blank" rel="noopener noreferrer" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                      Twitter / X
                    </a>
                  </li>
                  <li>
                    <a href="https://www.linkedin.com/company/peptidex-ai" target="_blank" rel="noopener noreferrer" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                      LinkedIn
                    </a>
                  </li>
                  <li>
                    <a href="/about" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                      About
                    </a>
                  </li>
                  <li>
                    <a href="mailto:peptidex@vitalbridgex.com" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                      Contact
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-border/30 pt-8 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
          <p className="text-xs text-muted-foreground">
            © {currentYear} PEPTIDEX.AI. PeptideX is a brand of VitalBridgeX Holdings LLC, a US company.
          </p>
          <p className="text-sm text-muted-foreground max-w-xl text-left md:text-right">
            {FOOTER_DISCLAIMER}
          </p>
          <p className="text-xs text-muted-foreground max-w-xl text-left md:text-right">
            {AFFILIATE_DISCLOSURE} <a href="/disclosures" className="text-primary hover:underline">Disclosures</a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
